export function useProductState(variants: Record<string, any> | undefined) {
    const canMakeReservation: ComputedRef<Object> = computed(() => {
        if (typeof variants === 'undefined') {
            return false;
        }

        return variants.reduce((totalStock: number, variant: { options: any[] }) => {
            const variantStock: number = variant.options.reduce((optionStock: number, option) => {
                return optionStock + option.stock;
            }, 0);
            return totalStock + variantStock;
        }, 0);
    });

    const isSoldOut: ComputedRef<boolean> = computed(() => {
        if (typeof variants === 'undefined') {
            return true;
        }

        return variants[0].options.filter((o: { stock: number }) => o.stock > 0).length === 0;
    });

    return { canMakeReservation, isSoldOut };
}
